import { call, put, takeLatest } from 'redux-saga/effects';
import * as apollo from 'apollo/notes.query';
import { SET_NOTES_VIEW_OPTIONS } from 'containers/App/constants';
import { pushSiteNotification } from 'containers/App/actions';
import * as ProjectsSettingsTypes from 'containers/Settings/Projects/types';
import * as types from './types';

function* getNotes(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.getNotes, payload.weddingId);
    if (!response.errors) {
      yield put({ type: types.GET_NOTES_SUCCESS, payload: response.data.notesList });
    } else {
      yield put({ type: types.GET_NOTES_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.GET_NOTES_FAIL });
  }
}

function* searchNotes(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.searchNotes, payload);
    if(!response.errors){
      yield put({ type: types.SEARCH_NOTES_SUCCESS, payload: response.data.notesSearch });
    } else {
      yield put({ type: types.SEARCH_NOTES_FAIL, payload: response.errors });
    }
  } catch (err) {
    yield put({ type: types.SEARCH_NOTES_FAIL });
  }
}

function* getSingleNote() {
  try {
    yield put({ type: types.GET_SINGLE_NOTE_SUCCESS, payload: {} });
  } catch (err) {
    yield put({ type: types.GET_SINGLE_NOTE_FAIL });
  }
}

function* updateIndexPreferences(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.saveNotesPreferences, payload);
    yield put({ type: types.UPDATE_INDEX_PREFERENCES_SUCCESS });
    yield put({ type: SET_NOTES_VIEW_OPTIONS, payload: response.saveNotesPreferences.preferences });
  } catch (err) {
    yield put({ type: types.UPDATE_INDEX_PREFERENCES_FAIL });
  }
}

function* updateNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.updateNote, payload);
    yield put({ type: types.UPDATE_NOTE_SUCCESS, payload: response?.updateNote });
  } catch (err) {
    yield put({ type: types.UPDATE_NOTE_FAIL });
  }
}

function* deleteNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.deleteNote, payload);
    if (response.deleteNote.isDeleted) {
      yield put({ type: types.DELETE_NOTE_SUCCESS, payload: { id: payload } });
    } else {
      yield put({ type: types.DELETE_NOTE_FAIL });
    }
  } catch (err) {
    yield put({ type: types.DELETE_NOTE_FAIL });
  }
}

function* updateURL(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.updateURL, payload);
    yield put({ type: types.UPDATE_URL_SUCCESS, payload: response.editUrl.output });
  } catch (err) {
    yield put({ type: types.UPDATE_URL_FAIL });
  }
}

function* saveTemplate(action) {
  const { payload } = action || {};
  try {
    if (!payload?.noteTemplateFolderId) {
      const mutateResponse = yield call(apollo.createNoteTemplateFolder, payload);
      if (!mutateResponse.errors) {
        payload.noteTemplateFolderId = mutateResponse?.createNoteTemplateFolder?.templateFolder?.id;
        yield put({
          type: ProjectsSettingsTypes.CREATE_NOTE_TEMPLATE_FOLDER_SUCCESS,
          payload: mutateResponse?.createNoteTemplateFolder,
        });
        yield put({ type: ProjectsSettingsTypes.GET_NOTE_TEMPLATE_FOLDERS });
      } else {
        yield put({ type: ProjectsSettingsTypes.CREATE_NOTE_TEMPLATE_FOLDER_FAIL, payload: mutateResponse.errors });
      }
    }
    const response = yield call(apollo.saveTemplate, payload);
    yield put({ type: types.SAVE_TEMPLATE_SUCCESS, payload: response });
    yield put(pushSiteNotification({
      message: 'Note template was saved.',
      time: 3000,
    }));
    yield put({ type: types.GET_TEMPLATES });
  } catch (err) {
    yield put({ type: types.SAVE_TEMPLATE_FAIL });
  }
}

function* renameNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.renameNote, payload);
    yield put({ type: types.RENAME_NOTE_SUCCESS, payload: response.renameNote.output });
  } catch (err) {
    yield put({ type: types.RENAME_NOTE_FAIL });
  }
}

function* restrictionsNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.restrictionsNote, payload);
    yield put({ type: types.RESTRICTIONS_NOTE_SUCCESS, payload: response.restrictionsNote.output });
  } catch (err) {
    yield put({ type: types.RESTRICTIONS_NOTE_FAIL });
  }
}

function* reorderNotes(action) {
  const { payload } = action || {};
  try {
    const mutateResponse = yield call(apollo.reorderNotes, payload);
    if (!mutateResponse.errors) {
      yield put({ type: types.REORDER_NOTES_SUCCESS, payload: mutateResponse.reorderNotes });
      yield put({
          type: types.GET_NOTES,
        payload: { weddingId : mutateResponse.reorderNotes.weddingId, notesLoading: false },
        });
    } else {
      yield put({ type: types.REORDER_NOTES_FAIL, payload: mutateResponse.errors });
    }
  } catch (err) {
    yield put({ type: types.REORDER_NOTES_FAIL, payload: err });
  }
}

function* createNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.createNote, payload);
    const { note } = response.data.createNotes;
    const { url, weddingId, id } = note;

    if (!url) {
      window.location = `/app/project/${weddingId}/tools/notes/${id}`;
    } else {
      yield put({ type: types.CREATE_NOTE_SUCCESS, payload: note });
      yield put({ type: types.GET_NOTES, payload: { weddingId: payload.weddingId, notesLoading: false } });
    }
  } catch (err) {
    yield put({ type: types.CREATE_NOTE_FAIL });
  }
}

function* createNoteFromTemplate(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.createNoteFromTemplate, payload);

    yield put({ type: types.CREATE_NOTE_SUCCESS, payload: response.data.createNotesFromTemplate.notes });
    yield put({ type: types.GET_NOTES, payload: { weddingId: payload.weddingId, notesLoading: false } });
  } catch (err) {
    yield put({ type: types.CREATE_NOTE_FAIL });
  }
}

function* duplicateNote(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.duplicateNote, payload);
    yield put({ type: types.DUPLICATE_NOTE_SUCCESS, payload: response.data.duplicateNote.note });
    yield put({
      type: types.GET_NOTES,
      payload: { weddingId: response.data.duplicateNote.note.weddingId, notesLoading: false },
    });
  } catch (err) {
    yield put({ type: types.DUPLICATE_NOTE_FAIL });
  }
}

function* getNotesTemplates() {
  const response = yield call(apollo.getNotesTemplates);
  try {
    yield put({ type: types.GET_TEMPLATES_SUCCESS, payload: response.data });
  } catch (err) {
    yield put({ type: types.GET_TEMPLATES_FAIL });
  }
}

function* reorderNoteTemplates(action) {
  const { payload } = action || {};
  try {
    const mutateResponse = yield call(apollo.reorderNoteTemplate, payload);
    if (!mutateResponse.errors) {
      yield put({ type: types.REORDER_NOTE_TEMPLATES_SUCCESS, payload: mutateResponse.reorderNoteTemplate });
      yield put({
        type: types.GET_TEMPLATES,
        payload: null,
      });
    } else {
      yield put({ type: types.REORDER_NOTE_TEMPLATES_FAIL, payload: mutateResponse.errors });
    }
  } catch (err) {
    yield put({ type: types.REORDER_NOTE_TEMPLATES_FAIL, payload: err });
  }
}

function* getNoteGroups(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.getNoteGroups, payload);
    yield put({
      type: types.GET_NOTE_GROUPS_SUCCESS,
      payload: { groupList: [...response.data.notesGroupsList].reverse() },
    });
  } catch (err) {
    yield put({ type: types.GET_NOTE_GROUPS_FAIL });
  }
}

function* createNoteGroup(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.createNoteGroup, payload);
    yield put({
      type: types.CREATE_NOTE_GROUP_SUCCESS,
      payload: { notesGroups: response.data.createNotesGroup.notesGroups },
    });
  } catch (err) {
    yield put({ type: types.CREATE_NOTE_GROUP_FAIL });
  }
}

function* renameNoteGroup(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.renameNoteGroup, payload);
    yield put({
      type: types.RENAME_NOTE_GROUP_SUCCESS,
      payload: {
        groupName: response.renameNotesGroup.notesGroup.name,
        groupId: response.renameNotesGroup.notesGroup.id,
      },
    });
  } catch (err) {
    yield put({ type: types.RENAME_NOTE_GROUP_FAIL });
  }
}

function* deleteNoteGroup(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.deleteNoteGroup, payload);
    yield put({
      type: types.DELETE_NOTE_GROUP_SUCCESS,
      payload: {
        groupId: response.deleteNotesGroup.id,
        notesGroupId: response.deleteNotesGroup.notesGroupId,
        groupNotes: response.deleteNotesGroup.groupNotes,
      },
    });
  } catch (err) {
    yield put({ type: types.DELETE_NOTE_GROUP_FAIL });
  }
}

function* reorderNoteGroup(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.reorderNoteGroup, payload);
    yield put({ type: types.REORDER_NOTE_GROUP_SUCCESS });
    yield put({
      type: types.GET_NOTE_GROUPS,
      payload: { weddingId: response.reorderNotesGroups.weddingId },
    });
  } catch (err) {
    yield put({ type: types.REORDER_NOTE_GROUP_FAIL });
  }
}

function* updateNoteGroupsView(action) {
  const { payload } = action || {};
  const { groupId, groupExpand } = payload;
  try {
    yield put({ type: types.UPDATE_NOTE_GROUP_VIEW_SUCCESS, payload: { groupId, groupExpand } });
    const response = yield call(apollo.updateNoteGroupsView, payload);
    if (response.errors) {
      yield put({ type: types.UPDATE_NOTE_GROUP_VIEW_FAIL });
    }
  } catch (err) {
    yield put({ type: types.UPDATE_NOTE_GROUP_VIEW_FAIL });
  }
}

function* createNoteComment(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.createNoteComment, payload);
    if (response.errors) {
      yield put({ type: types.CREATE_NOTE_COMMENT_FAIL });
    } else {
      yield put({
        type: types.CREATE_NOTE_COMMENT_SUCCESS,
        payload: {
          comment: response.createNoteComment.comment,
          noteId: payload.noteId,
        },
      });
    }
  } catch (err) {
    yield put({ type: types.CREATE_NOTE_COMMENT_FAIL });
  }
}

function* updateNoteComment(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.updateNoteComment, payload);
    if (response.errors) {
      yield put({ type: types.UPDATE_NOTE_COMMENT_FAIL });
    } else {
      yield put({
        type: types.UPDATE_NOTE_COMMENT_SUCCESS,
        payload: {
          comment: response.updateNoteComment.comment,
          noteId: payload.noteId,
        },
      });
    }
  } catch (err) {
    yield put({ type: types.UPDATE_NOTE_COMMENT_FAIL });
  }
}

function* deleteNoteComment(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.deleteNoteComment, payload);
    if (response.errors) {
      yield put({ type: types.DELETE_NOTE_COMMENT_FAIL });
    } else {
      yield put({ type: types.DELETE_NOTE_COMMENT_SUCCESS, payload });
    }
  } catch (err) {
    yield put({ type: types.DELETE_NOTE_COMMENT_FAIL });
  }
}

function* createNoteTemplate(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.createNoteTemplate, payload);
    const { url, id } = response.createNoteTemplate.noteTemplate;
    if (!url) {
      window.location = `/app/v2/pro/141/settings/templates/notes-templates/${id}`;
      return;
    }
    yield put({ type: types.CREATE_NOTE_TEMPLATE_SUCCESS, payload: response });
    yield put({ type: types.GET_TEMPLATES });
  } catch (err) {
    yield put({ type: types.CREATE_NOTE_TEMPLATE_FAIL });
  }
}

function* updateNoteTemplate(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.updateNoteTemplate, payload);
    if (response?.updateNoteTemplate?.noteTemplate) {
      yield put({ type: types.UPDATE_NOTE_TEMPLATE_SUCCESS, payload: response?.updateNoteTemplate });
    }
  } catch (err) {
    yield put({ type: types.UPDATE_NOTE_TEMPLATE_FAIL });
  }
}

function* deleteNoteTemplate(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.deleteNoteTemplate, payload);
    yield put({ type: types.DELETE_NOTE_TEMPLATE_SUCCESS, payload: response });
    yield put({ type: types.GET_TEMPLATES });
  } catch (err) {
    yield put({ type: types.DELETE_NOTE_TEMPLATE_FAIL });
  }
}

function* duplicateNoteTemplate(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.duplicateNoteTemplate, payload);
    yield put({
      type: types.DUPLICATE_NOTE_TEMPLATE_SUCCESS,
      payload: response.data.duplicateNoteTemplate.noteTemplate,
    });
    yield put({ type: types.GET_TEMPLATES });
  } catch (err) {
    yield put({ type: types.DUPLICATE_NOTE_TEMPLATE_FAIL });
  }
}

export default function* watchList() {
  yield takeLatest(types.GET_NOTES, getNotes);
  yield takeLatest(types.SEARCH_NOTES, searchNotes);
  yield takeLatest(types.GET_SINGLE_NOTE, getSingleNote);
  yield takeLatest(types.UPDATE_INDEX_PREFERENCES, updateIndexPreferences);
  yield takeLatest(types.UPDATE_NOTE, updateNote);
  yield takeLatest(types.DELETE_NOTE, deleteNote);
  yield takeLatest(types.UPDATE_URL, updateURL);
  yield takeLatest(types.SAVE_TEMPLATE, saveTemplate);
  yield takeLatest(types.REORDER_NOTE_TEMPLATES, reorderNoteTemplates);
  yield takeLatest(types.RENAME_NOTE, renameNote);
  yield takeLatest(types.REORDER_NOTES, reorderNotes);
  yield takeLatest(types.CREATE_NOTE, createNote);
  yield takeLatest(types.CREATE_NOTE_FROM_TEMPLATE, createNoteFromTemplate);
  yield takeLatest(types.DUPLICATE_NOTE, duplicateNote);
  yield takeLatest(types.GET_TEMPLATES, getNotesTemplates);
  yield takeLatest(types.CREATE_NOTE_TEMPLATE, createNoteTemplate);
  yield takeLatest(types.UPDATE_NOTE_TEMPLATE, updateNoteTemplate);
  yield takeLatest(types.DELETE_NOTE_TEMPLATE, deleteNoteTemplate);
  yield takeLatest(types.DUPLICATE_NOTE_TEMPLATE, duplicateNoteTemplate);
  yield takeLatest(types.GET_NOTE_GROUPS, getNoteGroups);
  yield takeLatest(types.CREATE_NOTE_GROUP, createNoteGroup);
  yield takeLatest(types.DELETE_NOTE_GROUP, deleteNoteGroup);
  yield takeLatest(types.RENAME_NOTE_GROUP, renameNoteGroup);
  yield takeLatest(types.REORDER_NOTE_GROUP, reorderNoteGroup);
  yield takeLatest(types.RESTRICTIONS_NOTE, restrictionsNote);
  yield takeLatest(types.UPDATE_NOTE_GROUP_VIEW, updateNoteGroupsView);
  yield takeLatest(types.CREATE_NOTE_COMMENT, createNoteComment);
  yield takeLatest(types.UPDATE_NOTE_COMMENT, updateNoteComment);
  yield takeLatest(types.DELETE_NOTE_COMMENT, deleteNoteComment);
}
